<template>
  <div>
    <div style="display: inline-block; vertical-align: top;">
      <select ref="selectize-field" class="form-control input-xsmall" v-model="valueData">
        <option v-for="(option, index) in options" :key="index" :value="option">{{option}}</option>
      </select>
    </div>
    <button class="btn red action-reset-select" style="display: inline-block;" @click="resetClick"><i class="fa fa-times"></i></button>
  </div>
</template>

<script>
  export default {
    name: "timesheet-field-dropdown-hours",
    props: {
      layout: {
        type: Object,
        required: true
      },
      value: {
        default: null
      },
      index: {
        type: Number,
        required: false
      }
    },
    data() {
      return {
        layoutData: this.layout,
        valueData: this.value,
        options: [...Array(25).keys()],
        hourValueSelected: false
      }
    },
    watch: {
      value(newval) {
        this.valueData = newval;
      }
    },
    computed: {
      fieldType() {
        return this.layoutData.type
      },
      fieldLabel() {
        return this.layoutData.label
      },
    },
    mounted () {
      let that = this;

		  $(this.$refs["selectize-field"]).selectize({
        onChange(value) {
          value = parseFloat(value);
          that.valueData = value;

          if(!that.hourValueSelected) {
            that.hourValueSelected = true;

            var newvalues = [];
            newvalues.push({ text: value, value: value });

            if(value != 24) {
              newvalues.push({ text: value + 0.25, value: value + 0.25 });
              newvalues.push({ text: value + 0.50, value: value + 0.50 });
              newvalues.push({ text: value + 0.75, value: value + 0.75 });
            }

            this.clearOptions();
            this.load(function(callback) {
              callback(newvalues);
            });
			      this.refreshOptions(true);
          }

          that.onChange(null);
        }
      });
    },
    methods: {
      onChange(e) {
        this.$emit("change", e, this.layoutData, this.valueData, this.index);
      },
      resetClick() {
        this.hourValueSelected = false;
        let selectize = this.$refs["selectize-field"].selectize;
        this.valueData = null;
        selectize.setValue("");
        selectize.clearOptions();
        selectize.load(function(callback) {
          callback([...Array(25).keys()].map(e => ({text:e,value:e})));
        });
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>